














































import Vue from 'vue';
export default {
  name: 'BeneficiaryDetails',
  props: ['data'],
  computed: {
    noBeneficiariesMsg() {
      if (this.splitAccountType(this.data.investment.accountType) === 'Joint') {
        return `In the event of death, we will pay benefits to your reversionary partner ${this.reversionaryPartner}`;
      }
      if (this.splitAccountType(this.data.investment.accountType) === 'Individual') {
        return 'As there is no beneficiary to receive benefits in the event of death, we will generally pay benefits to the Estate.';
      }
    },
    reversionaryPartner() {
      if (this.data.investment.jointInvestors && this.data.investment.jointInvestors[0]) {
        return this.data.investment.jointInvestors[0];
      }
      return '';
    },
  },
  methods: {
    splitAccountType(accountType) {
      return accountType.split('/')[0];
    },
  },
};
